import { Box, Spinner, Text } from 'grommet';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { ModalBase } from './Common/ModalBase';

const FieldProcessingModal = () => {
  const { t } = useTranslation();

  return (
    <ModalBase title={t('fieldFlow.fieldProcessing.processingModalTitle')}>
      <Box margin='1.5rem 0'>
        <Text
          style={{
            fontSize: '20px',
            lineHeight: '30px',
            textAlign: 'center',
          }}>
          {t('fieldFlow.fieldProcessing.processingModalText')}
        </Text>
      </Box>
      <Box height={'100%'} align={'center'} justify={'center'}>
        <Spinner color={'#FFE137'} size={'large'} />
      </Box>
    </ModalBase>
  );
};

export default FieldProcessingModal;
